import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogRef } from '../../../core/factory/dialog//utils';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationDialogComponent implements OnInit {

  constructor(
    public config: DialogConfig,
    public dialog: DialogRef,
  ) { }

  ngOnInit(): void {
    console.log(this.config);
    console.log(this.dialog);
  }

  onClose(): void {
    this.dialog.close({
      action: 'confirm',
      message: 'notification seen',
    });
  }
}
